import { NgModule } from "@angular/core";
import { NouisliderModule } from "ng2-nouislider";
import { SearchResultsComponent } from "apps-module/app/entry-modules/assistants-profile-search/components/search-results/search-results.component";
import { ResultItemComponent } from "apps-module/app/entry-modules/assistants-profile-search/components/search-results/result-item/result-item.component";
import { AssistantsProfileSearchComponent } from "apps-module/app/entry-modules/assistants-profile-search/assistants-profile-search.component";
import { CommonComponentsModule } from "apps-module/app/common-components/common-components.module";
import { BooleanDropdownFilterComponent } from "apps-module/app/entry-modules/assistants-profile-search/components/boolean-dropdown-filter/boolean-dropdown-filter.component";

@NgModule({
    declarations: [
        BooleanDropdownFilterComponent,
        AssistantsProfileSearchComponent,
        ResultItemComponent,
        SearchResultsComponent
    ],
    exports: [AssistantsProfileSearchComponent],
    imports: [
        CommonComponentsModule,
        NouisliderModule
    ]
})
export class AssistantsProfileSearchModule { }
